import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetProjectSurveyDetailsRPC } from "./getProjectSurveyDetailsRPC";

export class GetProjectSurveyDetailsRPCClientImpl extends GetProjectSurveyDetailsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetProjectSurveyDetailsRPC.Request): Promise<LeoRPCResult<GetProjectSurveyDetailsRPC.Response, GetProjectSurveyDetailsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/GetProjectSurveyDetails",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetProjectSurveyDetailsRPC.ResponseDTO,
      GetProjectSurveyDetailsRPC.Errors.ErrorsDTO,
      GetProjectSurveyDetailsRPC.Response,
      GetProjectSurveyDetailsRPC.Errors.Errors
    >(
      response,
      "project/GetProjectSurveyDetails",
      GetProjectSurveyDetailsRPC.Response.fromDTO,
      GetProjectSurveyDetailsRPC.Errors.fromDTO
    );
  }
}
